module.exports = __webpack_public_path__ + "static/img/product5.a3d05cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yiBrand/new/product5.png
// module id = CJsu
// module chunks = 0